import { useQuery } from "@tanstack/react-query";
import { AmazonianHardwareWithTaxonomyID } from "@amzn/amazonian-hardware-catalogical";
import { CatalogService } from "@/services/catalog/catalog-service";

const catalogService = new CatalogService();

export function useHardwareDetails(taxonomyId: string | undefined) {
  const { data, error, isLoading } = useQuery({
    queryKey: ["catalog-item", taxonomyId],
    queryFn: () => catalogService.getItem(taxonomyId!),
    enabled: !!taxonomyId,
  });

  return {
    data: data as AmazonianHardwareWithTaxonomyID | undefined,
    error: error ?? undefined,
    isLoading,
  };
}
